import * as actions from 'src/store/user-info/user-info.actions';
import * as userActions from 'src/store/user/user.actions';
import * as requests from 'src/services/requests/cities-and-agencies/cities-and-agencies';
import { updateUserProperties } from 'src/utils/analytics';
import { buildUserAnalyticsProperties } from 'src/store/initialization/initialization.operations';
import { userAgenciesSelector } from 'src/store/user-info/user-info.selectors';
import { findJurisdictionInAgencies } from 'src/utils/user-preferences/user-preferences';

/**
 * Lazy-load the full cities list from GET /cities.
 * Only used by the admin Requests page.
 */
export const getCitiesOperation = () => (dispatch) => {
    dispatch(actions.getAllCitiesRequest());

    return requests
        .getCities()
        .then((response) => {
            dispatch(actions.getAllCitiesSuccess(response));
        })
        .catch((error) => {
            dispatch(actions.getAllCitiesError(error));
        });
};

/**
 * Set the selected jurisdiction for the traffic-viewer flow and keep analytics
 * user_properties in sync so events fired after this point carry the new
 * jurisdiction attribution.
 *
 * UI components should prefer this thunk over dispatching
 * `setSelectedJurisdiction` directly, so analytics stays co-located with the
 * state change instead of scattered across components.
 */
export const setSelectedJurisdictionOperation = (jurisdictionId) => (dispatch, getState) => {
    dispatch(actions.setSelectedJurisdiction(jurisdictionId));

    const { list } = userAgenciesSelector(getState());
    const parentAgency = findJurisdictionInAgencies(list, jurisdictionId);
    if (parentAgency) {
        dispatch(userActions.setUserSelectedLocation({
            agencyId: parentAgency.agencyId,
            cityId: parentAgency.jurisdictionId,
        }));
        dispatch(userActions.setUserAgencyId(parentAgency.agencyId));
    }

    updateUserProperties(buildUserAnalyticsProperties(getState()));
};
